import { EnviromentVariable } from '@env/environment.model';
import packageJson from '../../package.json';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment: EnviromentVariable = {
  appName: 'Inspekt',
  envName: 'DEV',
  production: false,
  versions: {
    app: packageJson.version,
    angular: packageJson.dependencies['@angular/core'],
    ngrx: packageJson.dependencies['@ngrx/store'],
    material: packageJson.dependencies['@angular/material'],
    bootstrap: packageJson.dependencies.bootstrap,
    rxjs: packageJson.dependencies.rxjs,
    angularCli: packageJson.devDependencies['@angular/cli'],
    typescript: packageJson.devDependencies['typescript']
  },
  authConfig: {
    // Url of the Identity Provider
    issuer: 'https://devauth.inspekt.io',

    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin,

    // URL of the SPA to redirect the user after silent refresh
    silentRefreshRedirectUri: window.location.origin,

    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'inspekt_website',

    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid profile email InspektApi',

    showDebugInformation: true,

    // Receive a notification when the user signs out with the identity provider
    sessionChecksEnabled: false
  },
  authEnabled: true,
  // apiEndpoint: 'http://localhost:55386/v1/',

  apiEndpoint: 'https://devapi.inspekt.io/v1/',
  pollingDurationInMs: 30000,
  appInsightsKey: '134ba112-22e6-487a-bf3a-a1dba71d21bc',
  notifyHub: 'https://devnotify.inspekt.io/hubs/inspekt',
  notifyEndpoint: 'https://devnotify.inspekt.io/api/inspekt',
  enableExtendedInformation: true
};
